import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './BestPerformers.css';
import { useLocalStorage } from "../../utils/useLocalStorage";
import { format, parseISO } from 'date-fns';
import Pagination from '../../CommonUI/Pagination/Pagination';
import MarketIPO from "../MarketIPO";
import { Vortex } from 'react-loader-spinner';

function BestPerformers() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        if (groupValue === "BSE") {
            const getUrlList = BaseURL + "BestPerformers";
            fetch(`${getUrlList}/BSE/main/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        } else if (groupValue === "NSE") {
            const getUrlNew = BaseURL + "BestPerformers";
            fetch(`${getUrlNew}/NSE/main/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        } else if (groupValue === "bse") {
            const getUrlNew = BaseURL + "BestPerformers";
            fetch(`${getUrlNew}/BSE/sme/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        } else if (groupValue === "nse") {
            const getUrlNew = BaseURL + "BestPerformers";
            fetch(`${getUrlNew}/NSE/sme/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        }
    }, [groupValue]);

    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        const getCocode = compcode_array[1];
        window.open("/IPO/IPO-Synopsis/" + getCoCodeId + "/" + getCocode, '_blank');
    };


    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    return (
        <>
            <div class="col-12 p-0 breadcrumIPo">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/ipo">IPO</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Best Performers</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='performer-loser-sc'>
                            <div className='performer-header'>
                                <h2><span>Best Performers</span></h2>
                            </div>
                            <MarketIPO optionValue="Best Performers" />

                            <div className='performer-right'>
                                <div className='performer-inner-select'>
                                    
                                    {/* aria-label="BSE NSE" */}
                                    <select aria-label="BSE NSE" onChange={(event) => { setGroupValue(event.target.value); }}>
                                        <option value="BSE" selected>BSE</option>
                                        <option value="NSE">NSE</option>
                                        <option value="bse">BSE SME</option>
                                        <option value="nse">NSE EMERGE</option>
                                    </select>
                                </div>

                            </div>
                            {/* <hr></hr> */}

                            {/* tabIndex={0} */}
                            <div className='performer-table table-responsive' tabIndex={0}>
                                <table className='table'>
                                    {(() => {
                                        if (groupValue === "BSE") {
                                            return (
                                                <>
                                                    <thead>
                                                        <tr>


                                                            <th className='text-left'>Company</th>
                                                            <th className='text-right'>Listing Date</th>

                                                            <th className='text-right'>Listing Price (&#8377;)</th>
                                                            <th className='text-right'>Offer Price (&#8377;)</th>

                                                            <th className='text-right'>LTP(&#8377;)</th>
                                                            <th className='text-right'>High(&#8377;)</th>
                                                            <th className='text-right'>Low(&#8377;)</th>

                                                            <th className='text-right'>Volume(Nos.)</th>
                                                            <th className='text-right'>Change(%)</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentTableData && currentTableData.map(
                                                            ({ lname, LISTDATE, listprice, HIGH, OfferPrice, CLOSE, LOW, PerChange, VOLUME, co_code }) => (
                                                                <tr>
                                                                    <td className="text-left"><h6 onClick={routeChange} data-id={lname + '-' + co_code}>{lname}</h6></td>
                                                                    <td className="text-right">{format(parseISO(LISTDATE), 'dd-MMM-yyyy')}</td>
                                                                    {/* <td className="text-right"> {(LISTDATE != null) ? LISTDATE.split('T')[0] : 0}</td> */}
                                                                    <td className="text-right">{listprice}</td>
                                                                    <td className="text-right">{OfferPrice}</td>

                                                                    <td className="text-right"> {(CLOSE != null) ? CLOSE.toFixed(2) : 0}</td>
                                                                    <td className="text-right"> {(HIGH != null) ? HIGH.toFixed(2) : 0}</td>
                                                                    <td className="text-right"> {(LOW != null) ? LOW.toFixed(2) : 0}</td>
                                                                    <td className="text-right">{VOLUME}</td>

                                                                    <td className="text-right"> {(PerChange != null) ? PerChange.toFixed(2) : 0}</td>
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </>)
                                        } else {
                                            return (
                                                <>
                                                    <thead>
                                                        <tr>


                                                            <th className='text-left'>Company</th>
                                                            <th className='text-right'>Listing Date</th>
                                                            <th className='text-right'>Listing Price (&#8377;)</th>
                                                            <th className='text-right'>Offer Price (&#8377;)</th>

                                                            <th className='text-right'>LTP(&#8377;)</th>
                                                            <th className='text-right'>High(&#8377;)</th>
                                                            <th className='text-right'>Low(&#8377;)</th>

                                                            <th className='text-right'>Volume(Nos.)</th>
                                                            <th className='text-right'>Change(%)</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentTableData && currentTableData.map(
                                                            ({ lname, LISTDATE, listprice, HIGH, OfferPrice, CLOSE, LOW, PerChange, VOLUME, co_code }) => (
                                                                <tr>
                                                                    <td className="text-left"><h6 onClick={routeChange} data-id={lname + '-' + co_code}>{lname}</h6></td>
                                                                    <td className="text-right">{format(parseISO(LISTDATE), 'dd-MMM-yyyy')}</td>
                                                                    {/* <td className="text-right"> {(LISTDATE != null) ? LISTDATE.split('T')[0] : 0}</td> */}
                                                                    <td className="text-right">{listprice}</td>
                                                                    <td className="text-right">{OfferPrice}</td>

                                                                    <td className="text-right"> {(CLOSE != null) ? CLOSE.toFixed(2) : 0}</td>
                                                                    <td className="text-right"> {(HIGH != null) ? HIGH.toFixed(2) : 0}</td>
                                                                    <td className="text-right"> {(LOW != null) ? LOW.toFixed(2) : 0}</td>
                                                                    <td className="text-right">{VOLUME}</td>

                                                                    <td className="text-right"> {(PerChange != null) ? PerChange.toFixed(2) : 0}</td>
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </>)
                                        }
                                    })()}
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }


                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default BestPerformers;